export default "__VITE_ASSET__c67e6d08__"